import { render, staticRenderFns } from "./barList.vue?vue&type=template&id=58cc8c9a&scoped=true&"
import script from "./barList.vue?vue&type=script&lang=js&"
export * from "./barList.vue?vue&type=script&lang=js&"
import style0 from "./barList.vue?vue&type=style&index=0&id=58cc8c9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cc8c9a",
  null
  
)

export default component.exports